import React, { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateDownloadID,
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import { errorMessage } from '../../config/errorsMsg';
import instance from '../../service/axiosInstane';
import { colors } from '../../config/constants';
import { ClickAwayListener } from '@mui/material';
import { flashBarTheme } from '../../config/flashBar';
import MuiTable from '../../components/MuiTable/MuiTable';
import qs from 'qs';
import { Role, SortOrderType } from '../../config/enum';
import Dailog from '../../components/Dailog/Dailog';
import { successMessage } from '../../config/keyword';
import { StateProps } from '../../redux/reducer';
import Button from '../../components/Button/Button';

type RequestProps = {
  Page: number;
  PageSize: number;
  SearchText: string;
  SortBy: string;
  SortOrder: string | number;
  userId?: string | null;
};

type WebsiteResultProps = {
  siteOrganizationId: string;
  siteId: string;
  organizationId: string;
  siteSequenceNumber: number;
  name: string;
  host: string;
  siteUrl: string;
};

type KeywordJobProps = {
  status: number;
  documentsStoreId: string;
  errorDocumentsStoreId: string;
  createdBy: string;
  createdDate: string;
  message: string;
  organizationId: string;
  categoryId: string;
  organizationName: string;
  categoryName: string;
  jobName: string;
};

type websiteListProps = {
  web: WebsiteResultProps[];
};

const columns = [
  {
    id: 'jobName',
    label: 'Job Name',
    minWidth: 70,
    align: 'left',
  },
  { id: 'createdDate', label: 'Created Date', minWidth: 110, align: 'center' },
  { id: 'status', label: 'Status', minWidth: 100, align: 'left' },
  {
    id: 'src-download',
    label: 'Source File',
    minWidth: 100,
    align: 'center',
  },
];

const Report = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [state, setState] = useState({
    siteOrgId: '',
    websiteURL: '',
    searchKeyword: '',
  });
  const [requestWebsites, setRequestWebsites] = useState<RequestProps>({
    Page: 1,
    PageSize: 20,
    SearchText: '',
    SortBy: 'siteUrl',
    SortOrder: 0,
    userId: '',
  });
  const [websiteList, setWebsiteList] = useState<websiteListProps>({
    web: [],
  });
  const [websiteCount, setWebsiteCount] = useState<number>(0);
  const [showWebsite, setShowWebsite] = useState(false);
  const [websiteLoading, setWebsiteLoading] = useState(false);
  const currentYear = new Date().getFullYear();
  const [showYear, setShowYear] = useState(false);
  const [year, setYear] = useState(currentYear);
  const [isDeletePopup, setIsDeletePopup] = useState<boolean>(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [keywordState, setKeywordState] = useState<KeywordJobProps[]>([
    {
      status: 0,
      documentsStoreId: '',
      errorDocumentsStoreId: '',
      createdBy: '',
      createdDate: '',
      message: '',
      organizationId: '',
      categoryId: '',
      organizationName: '',
      categoryName: '',
      jobName: '',
    },
  ]);
  const [requestJob, setRequestJob] = useState<any>({
    OrganizationFilter: [],
    CategoryFilter: [],
    StatusFilter: [],
    Page: 1,
    PageSize: 20,
    SearchText: '',
    SortBy: '',
    SortOrder: SortOrderType.ASC,
  });

  const yearOperation = () => {
    const years = [];
    for (let i = 0; i <= 3; i++) {
      years.push(currentYear - i);
    }
    return years;
  };

  useEffect(() => {
    const breadcrumb = [{ path: '/reports', name: 'Reports' }];
    dispatch(update_breadcrumb(breadcrumb));
    getWebsites(requestWebsites);
    if (userInfo.role === Role.Admin) {
      getKeywordsExportJob();
    }
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      getWebsites(requestWebsites);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [requestWebsites.SearchText]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setRequestWebsites({ ...requestWebsites, SearchText: e.target.value });
  };

  const getWebsites = async (obj: RequestProps) => {
    const payload = {
      ...obj,
      userId: userInfo.role === Role.User ? userInfo.id : null,
    };

    setWebsiteLoading(true);
    await instance
      .get('/weblinks/sites', {
        params: payload,
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data?.results !== null) {
            setWebsiteList((prevState: any) => ({
              ...prevState,
              web: response?.data?.results,
            }));

            setWebsiteCount(response?.data?.totalCount);
          } else {
            setWebsiteList({ ...websiteList, web: [] });
          }
          setWebsiteLoading(false);
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: errorMessage.oops,
        };
        dispatch(updateFlashBar(obj));
        setWebsiteLoading(false);
      });
  };

  const onClickWebsite = (row: WebsiteResultProps) => {
    setShowWebsite(false);
    setRequestWebsites({ ...requestWebsites, SearchText: '' });
    setState({
      ...state,
      siteOrgId: row.siteOrganizationId,
      websiteURL: row.siteUrl,
    });
  };

  const generateReport = async () => {
    if (state.siteOrgId !== '') {
      const obj: { siteOrganizationId: string; userId?: string | null } = {
        siteOrganizationId: state.siteOrgId,
        userId: userInfo.role === Role.User ? userInfo.id : null,
      };
      dispatch(updateIsLoading(true));
      await instance
        .post('weblinks/generate-weblinks-report', obj)
        .then((response) => {
          if (response.status === 200) {
            downloadReport(response.data.documentStoreId);
            dispatch(updateIsLoading(false));
          }
        })
        .catch((err) => {
          const obj = {
            isOpen: true,
            message: err.response.data.Message,
            type: flashBarTheme.ERROR,
          };
          dispatch(updateFlashBar(obj));
          dispatch(updateIsLoading(false));
        });
    }
  };

  const generateDmacaReport = async () => {
    if (year !== undefined) {
      const obj: { year: number } = {
        year: year,
      };
      dispatch(updateIsLoading(true));
      await instance
        .get(`dmca-files/generate-report?year=${year}`)
        .then((response) => {
          if (response.status === 200) {
            downloadReport(response.data.documentStoreId);
            dispatch(updateIsLoading(false));
          }
        })
        .catch((err) => {
          const obj = {
            isOpen: true,
            message: err.response.data.Message,
            type: flashBarTheme.ERROR,
          };
          dispatch(updateFlashBar(obj));
          dispatch(updateIsLoading(false));
        });
    }
  };

  const downloadReport = (documentId: string) => {
    const obj = {
      isShow: true,
      downloadGuid: documentId,
    };
    dispatch(updateDownloadID(obj));
  };

  const loadMore = () => {
    getWebsites({
      ...requestWebsites,
      PageSize: requestWebsites.PageSize + 20,
      Page: 1,
    });
    setRequestWebsites({
      ...requestWebsites,
      PageSize: requestWebsites.PageSize + 20,
      Page: 1,
    });
  };

  const getKeywordsExportJob = async () => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(requestJob, { arrayFormat: 'repeat' });
    const url = `/keywords-export?${queryString}`;
    await instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.results !== null) {
            setKeywordState(response.data.results);
          } else {
            setKeywordState([]);
          }
          dispatch(updateIsLoading(false));
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const srcFileDownload = (row: KeywordJobProps) => {
    const obj = {
      isShow: true,
      downloadGuid: row.documentsStoreId,
    };
    dispatch(updateDownloadID(obj));
  };

  const generateKeywordsReport = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .post(`/keywords-export`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.KEYWORDS_GENERATE_REPORT,
            type: flashBarTheme.SUCCESS,
          };
          getKeywordsExportJob();
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const generateSiteReport = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .post('site-organizations/generate-report')
      .then((response) => {
        if (response.status === 200) {
          downloadReport(response.data.documentStoreId);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const onDailogSubmit = () => {
    if (dialogTitle === 'Keywords') {
      generateKeywordsReport();
    } else if (dialogTitle === 'Site') {
      console.log('generate Site');
      generateSiteReport();
    }
    setIsDeletePopup(false);
  };

  return (
    <>
      <div className="mx-2">
        <PageHeading label="Reports Management" />
        {userInfo.role === Role.Admin ? (
          <>
            <div className="bg-white p-4 rounded-sm shadow-md">
              <div
                className={`text-[#176b87] mb-[10px] text-base md:text-lg border-b ${colors.primaryBorder}`}
              >
                Select the website and download the DMCA marked weblinks
              </div>
              <div className="flex space-x-6">
                <div className="relative flex w-full md:w-auto">
                  <div className="w-full">
                    <div className={`text-sm mb-1 ${colors.primaryText} pl-2`}>
                      Website
                    </div>
                    <div
                      onClick={() => setShowWebsite(true)}
                      className="h-8 sm:w-[300px] w-full bg-slate-50 border flex items-center relative outline-none pr-[60px] pl-4 text-sm rounded-sm focus:border-[#64CCC5] cursor-pointer"
                    >
                      {state.websiteURL === '' ? (
                        <div className="text-gray-400">
                          {'Please select website'}
                        </div>
                      ) : (
                        state.websiteURL
                      )}
                    </div>
                  </div>

                  {showWebsite && (
                    <ClickAwayListener
                      onClickAway={() => {
                        setShowWebsite(false);
                        getWebsites({
                          ...requestWebsites,
                          SearchText: '',
                          PageSize: 20,
                          Page: 1,
                        });
                        setRequestWebsites({
                          ...requestWebsites,
                          SearchText: '',
                          PageSize: 20,
                          Page: 1,
                        });
                      }}
                    >
                      <div
                        style={{
                          maxHeight: '300px',
                          overflow: 'auto',
                          border: '1px solid #ccc',
                        }}
                        className="bg-white absolute top-14 text-sm shadow-lg sm:w-[300px] max-h-[300px] w-full overflow-scroll z-[10] p-2 rounded-md"
                      >
                        {' '}
                        <div className="relative">
                          <input
                            onClick={() => setShowWebsite(true)}
                            className="h-6  w-full border relative outline-none pr-[60px] pl-4 text-sm rounded-sm focus:border-[#64CCC5]"
                            placeholder={'Search here'}
                            name={'searchKeyword'}
                            onChange={(
                              e: React.ChangeEvent<
                                HTMLInputElement | HTMLSelectElement
                              >
                            ) => handleChange(e)}
                            autoComplete="off"
                            value={requestWebsites.SearchText}
                          />
                          <div
                            className="absolute top-[2px] right-3 cursor-pointer text-gray-600"
                            onClick={() => {
                              setRequestWebsites({
                                ...requestWebsites,
                                SearchText: '',
                              });
                            }}
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </div>
                        </div>
                        <div>
                          {websiteList.web.length > 0 ? (
                            <div>
                              {websiteList.web?.map(
                                (item: WebsiteResultProps, index: number) => {
                                  return (
                                    <div
                                      key={index}
                                      className={`mt-2 cursor-pointer p-1 hover:bg-slate-200 ${
                                        websiteList.web.length !== index + 1 &&
                                        'border-b'
                                      }`}
                                      onClick={() => onClickWebsite(item)}
                                    >
                                      <div
                                        className={`text-sm ${colors.primaryText}`}
                                      >
                                        {item.siteUrl}
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          ) : (
                            <div>No results found!</div>
                          )}
                        </div>
                        {websiteCount >= requestWebsites.PageSize &&
                          websiteList.web.length > 0 && (
                            <div
                              className={`shadow-sm cursor-pointer mt-2 p-1 border border-sky-500 flex items-center justify-center text-sky-500`}
                              onClick={() => loadMore()}
                            >
                              Load More
                            </div>
                          )}
                      </div>
                    </ClickAwayListener>
                  )}
                </div>

                <div className="mt-7">
                  <i
                    onClick={() => generateReport()}
                    className={`fa-solid fa-cloud-arrow-down text-[25px] ${
                      state.siteOrgId === ''
                        ? 'text-gray-500'
                        : `${colors.primayIcon} cursor-pointer`
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div className="bg-white p-4 rounded-sm shadow-md mt-7">
              <div
                className={`text-[#176b87] mb-[10px] text-base md:text-lg border-b ${colors.primaryBorder}`}
              >
                Select the year and download the DMCA file report
              </div>
              <div className="md:flex space-x-6">
                <div className="relative flex w-auto">
                  <div className="w-full">
                    <div className={`text-sm mb-1 ${colors.primaryText} pl-2`}>
                      Year
                    </div>
                    <div
                      onClick={() => setShowYear(true)}
                      className="h-8 w-full bg-slate-50 border flex items-center relative outline-none p-4 text-sm rounded-sm focus:border-[#64CCC5] cursor-pointer"
                    >
                      {year}
                      <i className="ml-4 fa-solid fa-caret-down"></i>
                    </div>
                  </div>

                  {showYear && (
                    <ClickAwayListener onClickAway={() => setShowYear(false)}>
                      <div
                        onClick={() => setShowYear(false)}
                        className="bg-white absolute top-14 text-sm shadow-lg z-[10] px-4 py-1 rounded-md"
                      >
                        {yearOperation().map((item, index) => {
                          return (
                            <div
                              key={index}
                              onClick={() => setYear(item)}
                              className="hover:bg-blue-900 hover:text-white px-4 py-[2px] cursor-pointer"
                            >
                              {item}
                            </div>
                          );
                        })}
                      </div>
                    </ClickAwayListener>
                  )}
                </div>

                <div className="mt-7">
                  <i
                    onClick={() => generateDmacaReport()}
                    className={`fa-solid fa-cloud-arrow-down text-[25px] ${
                      year === 0
                        ? 'text-gray-500'
                        : `${colors.primayIcon} cursor-pointer`
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div className="bg-white p-4 rounded-sm shadow-md mt-7">
              <div
                className={`text-[#176b87] mb-[10px] text-base md:text-lg border-b ${colors.primaryBorder}`}
              >
                Click on generate button to generate keywords files
              </div>
              <div className="flex justify-between">
                <Button
                  label="Generate"
                  type="button"
                  buttonType="primary-pro"
                  onClick={() => {
                    setIsDeletePopup(true);
                    setDialogTitle('Keywords');
                  }}
                />
                <Button
                  label="Refresh"
                  type="button"
                  buttonType="primary-pro"
                  icon={<i className="fa-solid fa-arrows-rotate"></i>}
                  onClick={() => getKeywordsExportJob()}
                />
              </div>
              <div className="bg-slate-100 rounded-md mt-2">
                <div>
                  <MuiTable
                    columns={columns}
                    rows={keywordState}
                    onSrcFileDownload={srcFileDownload}
                  />
                </div>
              </div>
            </div>
            <div className="bg-white p-4 rounded-sm shadow-md mt-7">
              <div
                className={`text-[#176b87] mb-[10px] text-base md:text-lg border-b ${colors.primaryBorder}`}
              >
                Click on generate button to download the site report
              </div>
              <div className="flex justify-between">
                <Button
                  label="Generate"
                  type="button"
                  buttonType="primary-pro"
                  onClick={() => {
                    setIsDeletePopup(true);
                    setDialogTitle('Site');
                  }}
                />
              </div>
            </div>
            <div className="flex justify-center pt-8">
              <Dailog
                isDeletePopup={isDeletePopup}
                setIsPopupOpen={setIsDeletePopup}
                title={dialogTitle}
                onConfirm={onDailogSubmit}
                type={'generate'}
              />
            </div>
          </>
        ) : (
          <div className="bg-white p-4 rounded-sm shadow-md">
            <div
              className={`text-[#176b87] mb-[10px] text-base md:text-lg border-b ${colors.primaryBorder}`}
            >
              Click on generate button to generate DMCA marked weblinks
            </div>
            <div className="md:flex md:space-x-6">
              <div className="relative flex w-full md:w-auto">
                <div className="w-full">
                  <div className={`text-sm mb-1 ${colors.primaryText} pl-2`}>
                    Website
                  </div>
                  <div
                    onClick={() => setShowWebsite(true)}
                    className="h-8 sm:w-[300px] w-full bg-slate-50 border flex items-center relative outline-none pr-[60px] pl-4 text-sm rounded-sm focus:border-[#64CCC5] cursor-pointer"
                  >
                    {state.websiteURL === '' ? (
                      <div className="text-gray-400">{'Please select website'}</div>
                    ) : (
                      state.websiteURL
                    )}
                  </div>
                </div>

                {showWebsite && (
                  <ClickAwayListener
                    onClickAway={() => {
                      setShowWebsite(false);
                      getWebsites({
                        ...requestWebsites,
                        SearchText: '',
                        PageSize: 20,
                        Page: 1,
                        userId: userInfo.id,
                      });
                      setRequestWebsites({
                        ...requestWebsites,
                        SearchText: '',
                        PageSize: 20,
                        Page: 1,
                      });
                    }}
                  >
                    <div
                      style={{
                        maxHeight: '300px',
                        overflow: 'auto',
                        border: '1px solid #ccc',
                      }}
                      className="bg-white absolute top-14 text-sm shadow-lg sm:w-[300px] max-h-[300px] w-full overflow-scroll z-[10] p-2 rounded-md"
                    >
                      {' '}
                      <div className="relative">
                        <input
                          onClick={() => setShowWebsite(true)}
                          className="h-6  w-full border relative outline-none pr-[60px] pl-4 text-sm rounded-sm focus:border-[#64CCC5]"
                          placeholder={'Search here'}
                          name={'searchKeyword'}
                          onChange={(
                            e: React.ChangeEvent<
                              HTMLInputElement | HTMLSelectElement
                            >
                          ) => handleChange(e)}
                          autoComplete="off"
                          value={requestWebsites.SearchText}
                        />
                        <div
                          className="absolute top-[2px] right-3 cursor-pointer text-gray-600"
                          onClick={() => {
                            setRequestWebsites({
                              ...requestWebsites,
                              SearchText: '',
                            });
                          }}
                        >
                          <i className="fa-solid fa-xmark"></i>
                        </div>
                      </div>
                      <div>
                        {websiteList.web.length > 0 ? (
                          <div>
                            {websiteList.web?.map(
                              (item: WebsiteResultProps, index: number) => {
                                return (
                                  <div
                                    key={index}
                                    className={`mt-2 cursor-pointer p-1 hover:bg-slate-200 ${
                                      websiteList.web.length !== index + 1 &&
                                      'border-b'
                                    }`}
                                    onClick={() => onClickWebsite(item)}
                                  >
                                    <div className={`text-sm ${colors.primaryText}`}>
                                      {item.siteUrl}
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        ) : (
                          <div>No results found!</div>
                        )}
                      </div>
                      {websiteCount >= requestWebsites.PageSize &&
                        websiteList.web.length > 0 && (
                          <div
                            className={`shadow-sm cursor-pointer mt-2 p-1 border border-sky-500 flex items-center justify-center text-sky-500`}
                            onClick={() => loadMore()}
                          >
                            Load More
                          </div>
                        )}
                    </div>
                  </ClickAwayListener>
                )}
              </div>

              <div className="mt-6">
                <Button
                  label="Generate"
                  buttonType="primary"
                  type="button"
                  onClick={() => generateReport()}
                  disabled={state.siteOrgId === ''}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Report;
